import {
  Component,
  ElementRef,
  ViewChild,
  AfterViewInit,
  Input,
  OnDestroy,
  ChangeDetectorRef,
} from "@angular/core";
import { CameraModel, RecordModel } from "src/app/_models";
declare var Hls: any;
declare var document2: any;

@Component({
  selector: "app-hlsjs",
  templateUrl: "./hlsjs.component.html",
  styleUrls: ["./hlsjs.component.css"],
})
export class HlsjsComponent implements AfterViewInit, OnDestroy {
  @ViewChild("videoElement", { static: false }) videoRef!: ElementRef;
  @ViewChild("wrapperRef", { static: false }) wrapperRef!: ElementRef;
  @Input() record: RecordModel;
  @Input() camera: CameraModel;
  @Input() type: string;
  @Input() index: number = 0;
  loaded: boolean = false;
  player: any;

  scale = 1;
  originX = 0;
  originY = 0;
  dragging = false;
  startX = 0;
  startY = 0;

  constructor(private cdRef: ChangeDetectorRef) {}
  //#region life cycle hook
  ngAfterViewInit(): void {
    this.cdRef.detach(); // Tắt change detection cho component
    this.loaded = false;
    if (this.type === "LIVE_VIEW")
      setTimeout(() => this.initPlayer(), this.index * 800);
  }
  ngOnDestroy(): void {
    this.destroyPlayer();
  }
  //#endregion life cycle hook
  //#region funtion
  fullScreen() {
    const videoEl = this.videoRef.nativeElement;
    if (document.fullscreenElement) {
      document.exitFullscreen().catch((err) => {
        console.error("Thoát fullscreen thất bại:", err);
      });
    } else {
      if (videoEl.requestFullscreen) {
        videoEl.requestFullscreen();
      } else if ((videoEl as any).webkitRequestFullscreen) {
        (videoEl as any).webkitRequestFullscreen();
      } else if ((videoEl as any).msRequestFullscreen) {
        (videoEl as any).msRequestFullscreen();
      } else {
        console.warn("Trình duyệt không hỗ trợ fullscreen API.");
      }
    }
  }
  initPlayer() {
    this.setupZoomPanListeners();
    const video = this.videoRef.nativeElement;
    // const autoplay = this.type === "LIVE_VIEW" ? true : false;
    const videoSrc =
      this.type === "LIVE_VIEW" ? this.camera.streamUrl : this.record.url;
    this.loaded = false;
    video.onloadeddata = () => {
      this.loaded = true;
      this.cdRef.detectChanges(); // Cập nhật UI do đã tắt change detection
    };
    if (Hls.isSupported()) {
      this.player = new Hls({
        // // Giữ tối đa 120s trong buffer thay vì mặc định 30s
        // maxBufferLength: 120,
        // maxMaxBufferLength: 240,
        // // Khi đến gần live edge, giữ cách 20s
        // liveSyncDuration: 20,
        // // Cho phép prefetch fragment kế tiếp
        // startFragPrefetch: true,
        // // Retry khi tải segment thất bại
        // fragLoadingRetryDelay: 1000,
        // fragLoadingMaxRetry: 8,
        // // Dùng web worker để offload parsing
        // enableWorker: true,
        // // Tăng timeout để không dừng khi mạng chậm
        // fragLoadingTimeOut: 20000
        //090625
        lowLatencyMode: true,
        maxBufferLength: 5,
        maxMaxBufferLength: 10,
        maxBufferSize: 10 * 1024 * 1024,
        liveSyncDurationCount: 2,
        backBufferLength: 5,
        maxBufferHole: 0.5,
        startFragPrefetch: true,
        enableWorker: true,
        fragLoadingRetryDelay: 1000,
        fragLoadingMaxRetry: 6,
        manifestLoadingRetryDelay: 1000,
        manifestLoadingMaxRetry: 5,
      });
      this.loaded = true;
      this.player.loadSource(videoSrc);
      this.player.attachMedia(video);

      this.player.on(Hls.Events.ERROR, (event: any, data: any) => {
        if (data.fatal) {
          switch (data.type) {
            case Hls.ErrorTypes.NETWORK_ERROR:
              console.log("Lỗi mạng, thử startLoad lại");
              this.player.startLoad();
              break;
            case Hls.ErrorTypes.MEDIA_ERROR:
              console.log("Lỗi decode, thử recoverMediaError");
              this.player.recoverMediaError();
              break;
            default:
              console.log("Lỗi không recover được, destroy");
              this.player.destroy();
              this.initPlayer();
              break;
          }
        }
      });
    } else if (video.canPlayType("application/vnd.apple.mpegurl")) {
      video.src = videoSrc;
    } else {
      console.error("HLS is not supported in this browser.");
    }
  }
  destroyPlayer(): void {
    if (this.player) {
      this.player.destroy(); // Dừng và giải phóng instance HLS
      this.player = null;
    }
    if (this.videoRef?.nativeElement) {
      const video = this.videoRef.nativeElement;
      video.pause();
      video.removeAttribute("src");
      video.load(); // Xóa khỏi DOM hoàn toàn
    }
  }
  setupZoomPanListeners(){
    const wrapper = this.wrapperRef.nativeElement;
    wrapper.addEventListener("mousedown", (e: MouseEvent) => {
      if (this.scale <= 1) return;
      this.dragging = true;
      this.startX = e.clientX - this.originX;
      this.startY = e.clientY - this.originY;
      wrapper.style.cursor = "grabbing";
    });
    document.addEventListener("mousemove", (e: MouseEvent) => {
      if (!this.dragging) return;
      this.originX = e.clientX - this.startX;
      this.originY = e.clientY - this.startY;
      const rect = wrapper.getBoundingClientRect();
      const maxX = ((this.scale - 1) * rect.width) / 2;
      const maxY = ((this.scale - 1) * rect.height) / 2;
      this.originX = this.clamp(this.originX, -maxX, maxX);
      this.originY = this.clamp(this.originY, -maxY, maxY);
      this.updateTransform();
    });
    document.addEventListener("mouseup", () => {
      this.dragging = false;
      wrapper.style.cursor = "grab";
    });
    wrapper.addEventListener("wheel", (e: WheelEvent) => {
      e.preventDefault();
      this.zoom(e.deltaY < 0 ? 0.2 : -0.2);
    });
  }
  clamp(val: number, min: number, max: number) {
    return Math.min(Math.max(val, min), max);
  }

  updateTransform() {
    const video = this.videoRef.nativeElement;
    video.style.transform = `translate(${this.originX}px, ${this.originY}px) scale(${this.scale})`;
  }

  zoom(delta: number) {
    const prev = this.scale;
    this.scale = this.clamp(this.scale + delta, 1, 5);
    if (this.scale === prev) return;

    const rect = this.wrapperRef.nativeElement.getBoundingClientRect();
    const cx = rect.width / 2;
    const cy = rect.height / 2;

    this.originX -= (cx - this.originX) * (this.scale / prev - 1);
    this.originY -= (cy - this.originY) * (this.scale / prev - 1);

    const maxX = ((this.scale - 1) * rect.width) / 2;
    const maxY = ((this.scale - 1) * rect.height) / 2;

    this.originX = this.clamp(this.originX, -maxX, maxX);
    this.originY = this.clamp(this.originY, -maxY, maxY);
    this.updateTransform();
  }
//   zoom(delta: number) {
//   const video = this.videoRef.nativeElement;
//   const wrapper = this.wrapperRef.nativeElement;

//   const prevScale = this.scale;
//   this.scale = this.clamp(this.scale + delta, 1, 5);
//   if (this.scale === prevScale) return;

//   const rect = wrapper.getBoundingClientRect();
//   const centerX = rect.width / 2;
//   const centerY = rect.height / 2;

//   // Tính thay đổi scale và điều chỉnh vị trí sao cho zoom từ tâm
//   const scaleDiff = this.scale / prevScale;

//   this.originX = (this.originX - centerX) * scaleDiff + centerX;
//   this.originY = (this.originY - centerY) * scaleDiff + centerY;

//   // Giới hạn để không kéo quá giới hạn
//   const maxX = (this.scale - 1) * rect.width / 2;
//   const maxY = (this.scale - 1) * rect.height / 2;

//   this.originX = this.clamp(this.originX, -maxX, maxX);
//   this.originY = this.clamp(this.originY, -maxY, maxY);

//   this.updateTransform();
// }

  zoomIn() {
    this.zoom(0.2);
  }
  zoomOut() {
    this.zoom(-0.2);
  }
  resetZoom() {
    this.scale = 1;
    this.originX = 0;
    this.originY = 0;
    this.updateTransform();
  }

 takeSnapshot() {
  const video: HTMLVideoElement = this.videoRef.nativeElement;
  if (!video || video.readyState < 2) {
    console.warn("Video chưa sẵn sàng để chụp.");
    return;
  }
  const canvas = document.createElement('canvas');
  canvas.width = video.videoWidth;
  canvas.height = video.videoHeight;

  const context = canvas.getContext('2d');
  if (!context) {
    console.error("Không thể lấy context của canvas.");
    return;
  }

  context.drawImage(video, 0, 0, canvas.width, canvas.height);
  const dataURL = canvas.toDataURL('image/png');
  const link = document.createElement('a');
  link.href = dataURL;
  link.download = `snapshot-${Date.now()}.png`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
  //#endregion funtion
}
